import api from '../services/api';
import Swal from 'sweetalert2';

export default function Suporte() {
  const container = document.createElement('div');
  container.className = 'content suporte-container';

  // Card de título
  const header = document.createElement('div');
  header.className = 'card';
  header.innerHTML = `<h2>Suporte Mobi Light</h2>`;
  container.appendChild(header);

  // Card do formulário
  const formCard = document.createElement('div');
  formCard.className = 'card';
  formCard.innerHTML = `
    <p style="font-size:14px;color:#ccc;text-align:left;margin-bottom:20px;">
      Use este formulário para entrar em contato com a equipe do MobiLight. 
      Você pode solicitar ajuda, relatar um problema, tirar dúvidas sobre sua conta ou assinatura, 
      solicitar exclusão de conta/dados ou enviar feedback sobre o app.<br><br>
      Para <b>excluir sua conta e seus dados</b>, escolha o assunto “Excluir minha conta/dados” 
      e use o mesmo e-mail cadastrado no MobiLight. 
      Detalhes sobre o tratamento dos seus dados estão na Política de Privacidade.
    </p>

    <form id="formSuporte" style="display:flex;flex-direction:column;gap:12px;text-align:left;max-width:600px;">
      
      <label>
        Assunto
        <select id="assunto" class="form-input">
          <option value="">Escolha o assunto</option>
          <option value="duvida">Dúvida</option>
          <option value="problema">Relatar problema</option>
          <option value="feedback">Enviar feedback</option>
          <option value="excluir">Excluir minha conta/dados</option>
        </select>
      </label>

      <label>
        Nome
        <input id="nome" type="text" class="form-input" placeholder="Seu nome" />
      </label>

      <label>
        E-mail
        <input id="email" type="email" class="form-input" placeholder="voce@email.com" />
      </label>

      <label>
        Mensagem
        <textarea id="mensagem" class="form-input" placeholder="Como podemos ajudar?" style="min-height:120px;"></textarea>
      </label>

      <div style="display:flex;gap:10px;justify-content:flex-start;">
        <button type="submit" class="btn primary" style="flex:1;">Enviar mensagem</button>      
      </div>
    </form>

    <p class="rodape" style="margin-top:20px;font-size:13px;color:#aaa;text-align:left;">
      Prefere e-mail? Escreva para <b style="color:#4caf50;">inbramed.sistemas@gmail.com</b>.<br>
      Veja também os Termos de Uso.
    </p>
  `;
  container.appendChild(formCard);

  // Lógica de envio
  formCard.querySelector('#formSuporte').addEventListener('submit', async (e) => {
    e.preventDefault();
    const assunto = document.getElementById('assunto').value;
    const nome = document.getElementById('nome').value;
    const email = document.getElementById('email').value;
    const mensagem = document.getElementById('mensagem').value;

    if (!assunto || !nome || !email || !mensagem) {
      alert('Por favor, preencha todos os campos.');
      return;
    }

    try {
      await api.post('/suporte', { assunto, nome, email, mensagem });
      Swal.fire('✅ Sucesso', 'Mensagem enviada com sucesso! Nossa equipe entrará em contato em breve.', 'success');
      e.target.reset();
    } catch (error) {
      alert(error.response?.data?.message || 'Erro ao enviar mensagem.');
    }
  });



  return container;
}
